/**
 * Client-side validation for the Hospitality quote request form.
 * Runs on submit and on blur/input, showing inline error messages
 * next to each field instead of relying on native browser bubbles.
 */
(function () {
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_PATTERN = /^[0-9+()\-.\s]{7,20}$/;

  var MESSAGES = {
    valueMissing: 'This field is required.',
    typeMismatch: 'Please enter a valid email address.',
  };

  function getFieldWrapper(input) {
    return input.closest('[data-hs-quote-field]');
  }

  function getErrorElement(input) {
    var wrapper = getFieldWrapper(input);
    return wrapper ? wrapper.querySelector('.hs-quote__error') : null;
  }

  function validateField(input) {
    var errorEl = getErrorElement(input);
    var wrapper = getFieldWrapper(input);
    var message = '';

    if (input.type === 'email' && input.value.trim() !== '' && !EMAIL_PATTERN.test(input.value.trim())) {
      message = MESSAGES.typeMismatch;
    } else if (input.type === 'tel' && input.value.trim() !== '' && !PHONE_PATTERN.test(input.value.trim())) {
      message = 'Please enter a valid phone number.';
    } else if (input.hasAttribute('required') && input.value.trim() === '') {
      message = MESSAGES.valueMissing;
    }

    var isValid = message === '';

    if (wrapper) {
      wrapper.classList.toggle('hs-quote__field--invalid', !isValid);
    }
    input.setAttribute('aria-invalid', isValid ? 'false' : 'true');

    if (errorEl) {
      errorEl.textContent = message;
    }

    return isValid;
  }

  function initForm(form) {
    var fields = form.querySelectorAll('input[required], input[type="email"], input[type="tel"]');

    fields.forEach(function (field) {
      field.addEventListener('blur', function () {
        validateField(field);
      });
      field.addEventListener('input', function () {
        var wrapper = getFieldWrapper(field);
        if (wrapper && wrapper.classList.contains('hs-quote__field--invalid')) {
          validateField(field);
        }
      });
    });

    form.addEventListener('submit', function (event) {
      var isFormValid = true;
      var firstInvalidField = null;

      fields.forEach(function (field) {
        var fieldIsValid = validateField(field);
        if (!fieldIsValid) {
          isFormValid = false;
          if (!firstInvalidField) {
            firstInvalidField = field;
          }
        }
      });

      if (!isFormValid) {
        event.preventDefault();
        if (firstInvalidField) {
          firstInvalidField.focus();
        }
      }
    });
  }

  document.querySelectorAll('.hs-quote__form').forEach(initForm);
})();
